"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ui_1 = require("@phishtool/ui");
const common_1 = __importDefault(require("~server/hydrate/common"));
const not_found_1 = __importDefault(require("~server/hydrate/not-found"));
const pages_1 = __importDefault(require("../conf/pages"));
exports.default = (siteStructure) => {
    const siteStructureRoutes = (0, ui_1.buildRoutes)({
        structure: siteStructure,
        hydrate: common_1.default,
        pages: pages_1.default,
    });
    const routes = [
        ...siteStructureRoutes,
        {
            path: '*',
            component: ui_1.NotFound,
            hydrate: not_found_1.default,
        },
    ];
    return routes;
};
